import { render, staticRenderFns } from "./info.view.vue?vue&type=template&id=73023c0b&scoped=true&lang=pug"
import script from "./info.view.vue?vue&type=script&lang=ts"
export * from "./info.view.vue?vue&type=script&lang=ts"
import style0 from "./info.view.vue?vue&type=style&index=0&id=73023c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73023c0b",
  null
  
)

export default component.exports